import React from 'react';

const UploadFileInfo = ({ files, enableBatchUpload }) => {
    if (!files || files.length === 0) {
        return null;
    }

    // Helper function to check if a file is a PDF
    const isPDFFile = (file) => {
        return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
    };

    // Separate PDF and non-PDF files
    const pdfFiles = files.filter(isPDFFile);
    const nonPdfFiles = files.filter(file => !isPDFFile(file));

    return (
        <div style={{ 
            margin: '10px 0',
            padding: '10px',
            backgroundColor: '#f8f9fa',
            borderRadius: '6px',
            border: '1px solid #dee2e6',
            fontSize: '12px'
        }}>
            <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#495057' }}>
                Upload Summary ({files.length} file{files.length !== 1 ? 's' : ''})
            </div>
            
            {pdfFiles.length > 0 && (
                <div style={{ marginBottom: '6px' }}>
                    <span style={{ 
                        backgroundColor: '#2196F3',
                        color: 'white',
                        padding: '2px 6px',
                        borderRadius: '3px',
                        fontSize: '10px',
                        marginRight: '8px'
                    }}>
                        PDF ({pdfFiles.length})
                    </span>
                    {enableBatchUpload && pdfFiles.length > 1 ? (
                        <span style={{ color: '#4caf50', fontWeight: 'bold' }}>
                            ✓ Will be merged into 1 document
                        </span>
                    ) : (
                        <span style={{ color: '#666' }}>
                            {pdfFiles.length === 1 ? 'Will be uploaded as-is' : 'Will be uploaded individually'}
                        </span>
                    )}
                </div>
            )}
            
            {nonPdfFiles.length > 0 && (
                <div>
                    <span style={{ 
                        backgroundColor: '#757575',
                        color: 'white',
                        padding: '2px 6px',
                        borderRadius: '3px',
                        fontSize: '10px',
                        marginRight: '8px'
                    }}>
                        OTHER ({nonPdfFiles.length})
                    </span>
                    <span style={{ color: '#666' }}>
                        Will be uploaded separately
                    </span>
                </div>
            )}
            
            {enableBatchUpload && pdfFiles.length > 1 && nonPdfFiles.length > 0 && (
                <div style={{ 
                    marginTop: '8px',
                    padding: '6px',
                    backgroundColor: '#e3f2fd',
                    borderRadius: '3px',
                    fontSize: '11px',
                    color: '#1565c0'
                }}>
                    <strong>Result:</strong> {nonPdfFiles.length + 1} file{nonPdfFiles.length > 0 ? 's' : ''} will be saved to SharePoint
                    <br />
                    <span style={{ fontSize: '10px' }}>
                        (1 merged PDF + {nonPdfFiles.length} other file{nonPdfFiles.length !== 1 ? 's' : ''})
                    </span>
                </div>
            )}
        </div>
    );
};

export default UploadFileInfo; 